export const notifyActionTypes = {
    SHOW_NOTIFY: 'N1',
    HIDE_NOTIFY: 'N2',
};


// export const notifyActionTypes = {
//     SHOW_NOTIFY: 'SHOW_NOTIFY',
//     HIDE_NOTIFY: 'HIDE_NOTIFY',
// };
